module.exports = __webpack_public_path__ + "static/media/thumbnail.4d1c425e.jpg";